var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillTriangle = function SvgFillTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fill_triangle_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fill_triangle_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill_triangle_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill_triangle_svg__st1",
    d: "M10.18 1.13.22 21.03C-.46 22.39.53 24 2.04 24h19.91c1.52 0 2.51-1.61 1.82-2.97l-9.96-19.9c-.74-1.51-2.88-1.51-3.63 0z"
  })));
};
export default SvgFillTriangle;